module.exports = __webpack_public_path__ + "img/pagetop_b.c721f18d.svg";